import React from 'react';
import { graphql } from 'gatsby';
import { EditoralImageBlock as EditoralImageBlockComponent } from '../../EditoralImageBlock';

export const EditoralImageBlock = ({ data, ...rest }) => <EditoralImageBlockComponent {...data} {...rest} />;

export const EditoralImageBlockQuery = graphql`
  fragment EditoralImageBlock on KFH_UmbracoEditoralImageBlockComponentType {
    title
    lead
    html
    stickyImage
    linkLists {
      ...LinkList
    }
    button {
      ...Button
    }
    image {
      altText
      width
      height
      mimeType
      filename
      url
      localFile {
        gatsbyImage(
          width: 544
          height: 720
          layout: CONSTRAINED
          cropFocus: CENTER
          placeholder: NONE
          quality: 80
          backgroundColor: "#F5F5F5"
        )
      }
    }
    alignment
    imageRight
  }
`;
